module.exports = __webpack_public_path__ + "img/logo.a665c4fa.png";